// lib/env.ts
// Единый источник URL. Не хардкодь домены нигде больше — импортируй отсюда.

function required(name: string, value: string | undefined): string {
  if (!value || value.trim() === '') {
    if (typeof window === 'undefined') {
      throw new Error(`[env] Missing required environment variable: ${name}`);
    }
    console.error(`[env] Missing ${name} — check Vercel Environment Variables`);
    return '';
  }
  return value.replace(/\/+$/, '');
}

function optional(value: string | undefined): string | undefined {
  if (!value || value.trim() === '') return undefined;
  return value.replace(/\/+$/, '');
}

export const env = {
  // Обязательные (валят билд если пусты)
  siteUrl: required('NEXT_PUBLIC_SITE_URL', process.env.NEXT_PUBLIC_SITE_URL),
  apiUrl:  required('NEXT_PUBLIC_API_URL',  process.env.NEXT_PUBLIC_API_URL),

  // Server-side (в API-роутах). Fallback на public API если серверный не задан.
  backendUrl: required(
    'BACKEND_URL',
    process.env.BACKEND_URL ?? process.env.NEXT_PUBLIC_API_URL
  ),

  // Опциональные

  routerUrlSrv:   optional(process.env.ROUTER_URL ?? process.env.NEXT_PUBLIC_AI_ROUTER_URL),
  gpuApiUrl:      optional(process.env.NEXT_PUBLIC_GPU_API_URL),
  opsUrl:         optional(process.env.NEXT_PUBLIC_OPS_URL),
  vapidPublicKey: optional(process.env.NEXT_PUBLIC_VAPID_PUBLIC_KEY),
};

// Домены куки для очистки в logout. Legacy держим тут — старые куки у юзеров
// могут остаться, надо чистить все возможные.
export const COOKIE_DOMAINS_TO_CLEAR = [
  '.layvers.com',    // текущий prod
  '.salaria.top',    // dev
  '.salaria.app',    // legacy, удалим после того как домен отвалится
];